import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axiosBaseApi from '@/services/common/lib/axiosBaseApi';

const LIMIT = 10;

interface user {
  id: string;
  alias: 'string';
  firstName: 'string';
  lastName: 'string';
  tier: {};
  readyPlayerMeUser: {};
}
export const getSearchUserRequest = (alias: string) => {
  return axiosBaseApi.get<user[]>(`/v1/user/search?alias=${alias}&limit=${LIMIT}`);
};

interface useSearchUserResult {
  data: user[];
}

const useSearchUser = ({ alias }: { alias: string }): UseQueryResult<useSearchUserResult, Error> => {
  return useQuery<useSearchUserResult, Error>({
    queryKey: ['searchUser', alias],
    queryFn: () => getSearchUserRequest(alias),
    refetchOnWindowFocus: true,
    enabled: alias !== '',
    staleTime: 0,
  });
};

export default useSearchUser;
